import { LoadModeTypes } from '@typeDefinitions/loadTypes';

import { IManagePostLoad, PostingMode } from './types';

export const POSTING_MODE_OPTIONS: { label: string; value: PostingMode }[] = [
  { label: 'Full Truckload', value: 'TL' },
  { label: 'LTL', value: 'LTL' },
  { label: 'Partial', value: 'Partial' },
];

// Other load modes (Intermodal, Air, Ocean) post as TL.
export const getPostingModeFromLoadMode = (
  mode: LoadModeTypes | undefined,
): PostingMode => (mode === 'LTL' || mode === 'Partial' ? mode : 'TL');

// Postings saved before mode existed only carry fullTruckload.
export const getPostingModeFromPosting = (posting: {
  mode?: PostingMode | null;
  fullTruckload: boolean;
}): PostingMode => posting.mode ?? (posting.fullTruckload ? 'TL' : 'LTL');

// Sends mode only when the ReleasePostingModeOptions FF is on.
export const getPostingModePayload = (
  mode: PostingMode,
  isModeOptionsEnabled: boolean,
): { mode?: PostingMode; fullTruckload: boolean } => ({
  mode: isModeOptionsEnabled ? mode : undefined,
  fullTruckload: mode === 'TL',
});

export const mapEditPostLoad = (formValues: Partial<IManagePostLoad>) => {
  // The equipment-code override fields are only supplied when the
  // posting_equipmentcode_override flag is on (the caller spreads the built
  // override payload into formValues). When the flag is off none are present,
  // so they are omitted here to keep the pre-feature request shape unchanged.
  const overrideFields = (
    [
      'atgOverride',
      'datOverride',
      'tsOverride',
      'tsSubcodeOverride',
      'mailerOverride',
    ] as const
  ).reduce<Record<string, string | null>>((acc, key) => {
    if (formValues[key] !== undefined) {
      acc[key] = formValues[key] ?? null;
    }
    return acc;
  }, {});

  return {
    id: formValues.id,
    loadId: formValues.loadId,
    boardsPostedTo: formValues.boardsPostedTo,
    servicesToPostTo: formValues.servicesToPostTo,
    origin: formValues.origin,
    originCity: formValues.originCity,
    originState: formValues.originState,
    originCountry: formValues.originCountry,
    destination: formValues.destination,
    destinationCity: formValues.destinationCity,
    destinationState: formValues.destinationState,
    destinationCountry: formValues.destinationCountry,
    price: formValues.price,
    pickUp: formValues.pickUp,
    dropOff: formValues.dropOff,
    equipment: formValues.equipment,
    comment: formValues.comment,
    drops: formValues.drops,
    length: formValues.length,
    weight:
      formValues.weight != null ? Math.round(formValues.weight) : undefined,
    mode: formValues.mode,
    fullTruckload: formValues.fullTruckload,
    internalNote: formValues.internalNote,
    mileage: formValues.mileage,
    tags: formValues.tags,
    originZip: formValues.originZip,
    destinationZip: formValues.destinationZip,
    datePosted: formValues.datePosted,
    ...overrideFields,
  };
};
